import { useMemo } from 'react';

export const useMemoizedSelector = <TSelector>(selector: TSelector): TSelector => {
    // Based on https://react-redux.js.org/api/hooks#useselector-examples and https://github.com/reduxjs/reselect#accessing-react-props-in-selectors
    // Each prop-based selector needs to get its own instance when used in multiple components
    return useMemo(() => selector, []);
};
